module.exports = __webpack_public_path__ + "static/media/jcb.5320bc5a.svg";